<template>
  <div class="pt-3" v-if="selectedConversation">
    <div class="d-flex justify-content-start align-items-center">
      <div class="flex-fill">
        <button class="btn btn-primary btn-sm" @click="getConversationSummary(selectedConversation.id)">
          สรุปบทสนทนา #{{ selectedConversation.id }}
        </button>
      </div>
      <div>
        <a href="" @click.prevent="showSummary = false" v-if="showSummary">ซ่อน</a>
        <a href="" @click.prevent="showSummary = true" v-else>แสดง</a>
      </div>
    </div>
    <div class="pt-3" v-show="showSummary">
      <div class="text-small summary-text" v-if="summaryText">
        <div v-html="summaryText"></div>
        <div class="pt-3" v-if="category">
          <span v-if="category === 'book_service'">
            <b>AI Suggest:</b>&nbsp;&nbsp;
            <span v-if="isRecommending">
              <img src="@/assets/img/audio_wave.gif" height="24"/>
            </span> <div v-html="recommendedBookingService"></div>
          </span>
          <span v-else-if="category === 'evaluate_duration'">
            <b>AI Suggest:</b>&nbsp;&nbsp;
            <span v-if="isRecommending">
              <img src="@/assets/img/audio_wave.gif" height="24"/>
            </span> {{ recommendedDuration }}
          </span>
          <span v-else-if="category === 'big_cleaning'">
            <b>AI Suggest:</b> ประสานงานเจ้าหน้าที่ Big Cleaning
          </span>
        </div>
      </div>
      <div class="text-center" v-if="isSummarizing">
        <img src="@/assets/img/audio_wave.gif" height="32"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    selectedConversation: Object
  },
  data () {
    return {
      isNewCustomer: false,
      activeConversationId: 0,
      category: null,
      isSummarizing: false,
      showSummary: true,
      summaryText: null,
      isRecommending: false,
      recommendedDuration: null,
      recommendedBookingService: null
    }
  },
  watch: {
    selectedConversation () {
      if (this.selectedConversation.id !== this.activeConversationId) {
        this.activeConversationId = this.selectedConversation.id
        this.showSummary = true
        this.summaryText = null
        this.isNewCustomer = (!this.selectedConversation.customer.beneat_user_id)
      }
    }
  },
  methods: {
    async getConversationSummary (id) {
      this.isSummarizing = true
      this.showSummary = true
      this.summaryText = null
      this.category = null
      const url = `/ai-assistant/conversation-summary/${id}`
      const { data } = await axios.get(url)
      this.isSummarizing = false
      if (data) {
        this.summaryText = data.summaryText
        this.category = data.category
        switch (this.category) {
          case 'book_service':
            this.recommendBookingService(data.inputText)
            break
          case 'evaluate_duration':
            this.recommendDuration(data.inputText)
            break
        }
      }
    },
    async recommendDuration (inputText) {
      this.isRecommending = true
      this.recommendedDuration = null
      const url = `/ai-assistant/recommend-duration`
      const { data } = await axios.post(url, { inputText })
      this.isRecommending = false
      if (data) {
        this.recommendedDuration = data.result
      }
    },
    async recommendBookingService (inputText) {
      console.log('check recommendBookingService', inputText)
      this.isRecommending = true
      this.recommendedBookingService = null
      const url = `/ai-assistant/recommend-booking-service`
      const { data } = await axios.post(url, {
        inputText: inputText,
        isNewCustomer: this.isNewCustomer
      })
      this.isRecommending = false
      if (data) {
        const formattedText = data.result.replace(/(\d\.)/g, '<br>$1 ')
        this.recommendedBookingService = formattedText
      }
    }
  }
}
</script>
